/* Henne · brand-mix featured collection (sections/henne-featured-mix.liquid).
   The server renders the collection with at most one product per brand first. This script then asks every brand
   in the section setting for its newest products (/collections/vendors?q=…&sort_by=created-descending, rendered by
   sections/henne-vendor-cards.liquid) and fills the grid round by round: the newest product of each brand
   (brands ordered by their newest product), then the second newest, and so on. If the requests fail or return
   too little, the server-rendered cards stay. Products pinned in the section (data-hn-pin) always stay first. */
(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ROUNDS = 3; // the helper section renders up to 3 cards per brand

  const brandCards = (vendor) =>
    fetch(`${ROOT}collections/vendors?q=${encodeURIComponent(vendor)}&sort_by=created-descending&section_id=henne-vendor-cards`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const box = document.createElement('div');
        box.innerHTML = html;
        return [...box.querySelectorAll('[data-hn-handle]')];
      })
      .catch(() => []);

  async function mix(root) {
    if (root.dataset.hnMixDone) return;
    root.dataset.hnMixDone = '1';
    let vendors;
    try { vendors = JSON.parse(root.dataset.hnMixVendors || '[]'); } catch (e) { return; }
    const limit = parseInt(root.dataset.hnMixLimit, 10) || 6;
    const grid = root.querySelector('.m-mixed-layout__inner');
    if (!grid || !vendors.length) return;

    const lists = (await Promise.all(vendors.map(brandCards)))
      .filter((l) => l.length)
      .sort((a, b) => Number(b[0].dataset.hnCreated) - Number(a[0].dataset.hnCreated));
    if (lists.length < 2) return; // nothing to mix: keep the server cards

    let pins = [];
    try { pins = JSON.parse(root.dataset.hnPin || '[]'); } catch (e) { pins = []; }
    const serverCards = [...grid.querySelectorAll(':scope > [data-hn-handle]')];
    const picked = pins.map((h) => serverCards.find((c) => c.dataset.hnHandle === h)).filter(Boolean).slice(0, limit);
    const seen = new Set(picked.map((c) => c.dataset.hnHandle));
    for (let round = 0; round < ROUNDS && picked.length < limit; round++) {
      for (const list of lists) {
        const card = list[round];
        if (!card || picked.length >= limit || seen.has(card.dataset.hnHandle)) continue;
        seen.add(card.dataset.hnHandle);
        picked.push(card);
      }
    }
    // Top up from the server-rendered cards if the brands ran out.
    for (const card of serverCards) {
      if (picked.length >= limit) break;
      if (!seen.has(card.dataset.hnHandle)) { seen.add(card.dataset.hnHandle); picked.push(card); }
    }
    grid.replaceChildren(...picked);
  }

  const run = () => document.querySelectorAll('[data-hn-mix-vendors]').forEach(mix);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', run);
})();
